import React, { useState } from "react";
import {
  SingleButton, SimpleButton, Button, FillButton, BorderButton, GrayButton,
  EmptyButton, ThinButton, TwinColumn, SplitRowHalf, SplitRowQuarter,
  CopyButton, ReserveButton,
} from "./ButtonGroup";
import {
  HeaderIconLR,
  HeaderIconL,
  HeaderIconLActionR,
  HeaderIconLIconsR,
  HeaderLeftTitleSubtitle,
} from "./HeaderGroup";
import { Chip } from "./Chip"
import Placeholder from "./Placeholder";
import PlaceholderB from "./PlaceholderB"
import { SelectCard, SelectCardWithSub, SelectBoxB } from "./SelectGroup";
import { Bottom, BottomWithButton } from "./BottomSheetGroup"
import band_mini from "../icons/Channel/band_mini.svg"
import arrowleft from "../icons/Arrow/left.svg"
import { useToast } from "../../hooks/useToast";
import ReserveCard from "./ReserveGroup"
import Popup from "./PopupGroup";
import info from "../icons/System/info.svg"

// bottom 컴포넌트 예시용
const OPTIONS_SIMPLE = ["옵션 A", "옵션 B", "옵션 C"];
const OPTIONS_WITH_BUTTON = ["선택 1", "선택 2", "선택 3"];

// 복붙
async function copyTextSafe(text) {
  try {
    if (
      typeof navigator !== "undefined" &&
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === "function"
    ) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    textarea.style.top = "-9999px";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch (e) {
    console.error("copyTextSafe error:", e);
    return false;
  }
}



export default function ManualMarketingGallery() {
  const [activeSheet, setActiveSheet] = useState(null);
  // Simple 시트 선택 값
  const [bottomValue, setBottomValue] = useState("");
  // WithButton 시트 확정 값 + 임시 값
  const [withButtonValue, setWithButtonValue] = useState("");
  const [withButtonTemp, setWithButtonTemp] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [open2, setOpen2] = useState(false);

  const openBottom = () => setActiveSheet("simple");
  const closeBottom = () => setActiveSheet(null);

  const handleSelect = (opt) => {
    setBottomValue(opt);
    closeBottom();
  }

  const openWithButtonSheet = () => {
    // 열 때 현재 확정 값 기준으로 temp 세팅
    setWithButtonTemp(withButtonValue || "");
    setActiveSheet("withButton");
  };

  const closeWithButtonSheet = () => {
    // 닫을 때는 temp를 롤백 (확정값 유지)
    setWithButtonTemp(withButtonValue || "");
    setActiveSheet(null);
  };

  // 오른쪽 버튼(확인): temp를 확정
  const handleConfirmWithButton = () => {
    setWithButtonValue(withButtonTemp || "");
    setActiveSheet(null);
  };

  // 왼쪽 버튼(취소): 선택 초기화 + 닫기
  const handleCancelWithButton = () => {
    setWithButtonTemp("");
    setWithButtonValue(""); // value도 비움 (요구사항)
    setActiveSheet(null);
  };

  const { showToast } = useToast();

  const handleCopy = async () => {
    const text = "복사할 텍스트"; // 실제 복사할 내용

    const success = await copyTextSafe(text);

    if (success) {
      showToast("텍스트를 입력해주세요.");
    } else {
      showToast("복사에 실패했습니다. 직접 복사해주세요.");
    }
  };

  const [open, setOpen] = React.useState(false);

  
  // PlaceholderB의 캡션 예시
  const [storeName, setStoreName] = useState("");
  const validateStoreName = (value) => {
    if (!value) {
      return { status: "error", message: "매장 이름을 입력해주세요" };
    }
    if (/[0-9]/.test(value)) {
      return { status: "error", message: "숫자는 사용할 수 없어요" };
    }
    return { status: "default", message: "" }; // 캡션 없음
  };

  return (
    <div className="p-4 space-y-3">
      {/* 예약 카드 예시 */}
      <div className="space-y-2">
        <ReserveCard
          title="이벤트명을 입력하세요"
          startDate="2025.09.19"
          endDate="2025.12.30"
          uploadTimes={["12:00", "12:00", "12:00", "12:00", "12:00"]}
          onDelete={() => setOpen(true)}
          onEdit={() => alert(2)}
          straight={"바로가기 없이 알림만 받기"}
        />
        <ReserveCard
          title="이벤트명을 입력하세요"
          startDate="2025.09.19"
          endDate="2025.09.30"
          weeklyDays={["월", "화", "수", "목", "금", "토", "일"]}
          uploadTimes={["12:00", "12:00", "12:00", "12:00", "12:00"]}
          onDelete={() => alert(1)}
          onEdit={() => alert(2)}
        />
        <ReserveCard
          title="이벤트명을 입력하세요"
          startDate="2025.09.19"
          endDate="2025.09.30"
          monthlyDays={["24", "26", "27", "28", "29", "30", "31"]}
          uploadTimes={["12:00", "12:00", "12:00", "12:00", "12:00"]}
          onDelete={() => alert(1)}
          onEdit={() => alert(2)}
        />

        <Popup
          isOpen={open}
          onClose={() => setOpen(false)}
          title="예약 알림을 삭제하시겠습니까?"
          subtitle={
            "서브텍스트를 입력해주세요\n서브텍스트를 입력해주세요서브텍스트를 입력해주세요"
          }
     
          // 아래 버튼은 직접 구성 (ButtonGroup 아무거나 사용 가능)
          renderButtons={
            <>
            <TwinColumn 
              topType={"alert"}
              topText={"네, 삭제할래요"}
              bottomType={"empty"}
              bottomText={"아니요"}
            />
            </>
          }
        />
      </div>

      {/* Select & BottomSheet 예시 */}
      <div className="space-y-1 p-3 border border-spacing-2 border-[#5950FF] rounded-2xl bg-black">
        <h2 className="text-t3 font-bold text-white">Select & BottomSheet 예시</h2>
        <SelectCard
          label="타이틀"
          value={bottomValue}
          placeholder="선택1"
          onClick={openBottom}
        />

        <SelectCardWithSub
          label="타이틀"
          placeholder="선택2"
          subLabel="서브타이틀을 입력하세요"
          value={withButtonValue}
          onClick={openWithButtonSheet}
        />

        <SelectBoxB
          title="예시"
          // value={selectedLabel}
          isOpen={open2}
          titleClassName="text-t2"   // text-b1 안 쓰고 text-t4만 사용
          useToggleIcon
          onClick={() => setOpen2((prev) => !prev)}
        >
          {/* 여기 안은 마음대로 구성 */}
          <div className="p-[16px] space-y-[8px]">
             <p className="text-c2 text-text-subtler">
              원하는 예약 알림 주기를 선택해주세요.
            </p>

            {["매일", "매주", "매월"].map((label) => (
              <label
                  key={label}
                  className="flex items-center gap-[8px] text-b2 text-text-default cursor-pointer"
                >
                  <input
                    type="radio"
                    name="reserve-cycle"
                    className="accent-primary-500"
                    checked={selectedLabel === label}
                    onChange={() => setSelectedLabel(label)}
                  />
                  <span>{label}</span>
                </label>
              ))}
          </div>
        </SelectBoxB>

        {/* --- Bottom: 선택 즉시 반영 & 닫힘 --- */}
        <Bottom
          isOpen={activeSheet === "simple"}
          onClose={closeBottom}
          title="옵션 선택"
        >
          <div className="flex flex-col gap-[8px] pt-[8px]">
            {OPTIONS_SIMPLE.map((opt) => (
              <button
                key={opt}
                type="button"
                onClick={() => handleSelect(opt)}
                className="w-full px-[16px] py-[12px] rounded-[12px] bg-surface-light-white text-left text-b1 text-text-default border border-btn-disabled-fill"
              >
                {opt}
              </button>
            ))}
          </div>
        </Bottom>

        {/* --- BottomWithButton: SplitRowHalf 사용 --- */}
        <BottomWithButton
          isOpen={activeSheet === "withButton"}
          onClose={closeWithButtonSheet}
          title="옵션 선택"
          subtitle="원하는 옵션을 선택한 후 확인을 눌러주세요"
          onSubmit={handleConfirmWithButton}
          renderButton={({ onClick }) => (
            <SplitRowHalf
              leftText="취소"
              rightText="확인"
              onLeft={handleCancelWithButton}
              onRight={onClick} // onClick = onSubmit = handleConfirmWithButton
            />
          )}
        >
          <div className="flex flex-col gap-[8px] pt-[8px]">
            {OPTIONS_WITH_BUTTON.map((opt) => {
              const isSelected = withButtonTemp === opt;
              return (
                <button
                  key={opt}
                  type="button"
                  onClick={() => setWithButtonTemp(opt)}
                  className={
                    "w-full px-[16px] py-[12px] rounded-[12px] text-left text-b1 border transition-all " +
                    (isSelected
                      ? "bg-surface-light-primary-light border-btn-secondary-border text-text-default"
                      : "bg-surface-light-white border-btn-disabled-fill text-text-subtler")
                  }
                >
                  {opt}
                </button>
              );
            })}
          </div>
        </BottomWithButton>
      </div>

      <div className="space-y-1 p-3 border border-spacing-2 border-[#5950FF] rounded-2xl">
        <h1 className="text-xl font-bold">Placeholder Test</h1>
        <section className="space-y-3">
          <h2 className="text-lg font-semibold">placeholder 테스트</h2>
          <Placeholder
            label="타이틀"
            placeholder="텍스트를 입력해주세요"
            maxLength={20}
          />
          <Placeholder
            size="large"
            label="size가 large일때"
            placeholder="설명을 입력해주세요"
            maxLength={100}
          />
          <hr/>
          <PlaceholderB            
            placeholder="텍스트를 입력해주세요"
            rightIconMode="static"
            rightIcon={<img src={info} alt="" />}
          />
          <PlaceholderB
            labelIcon={<img src={info} alt="" />}   // 예: 작은 물음표 아이콘
            label="가게 이름"
            placeholder="테스트 글자 적기"
            // value={storeName}
            // onChange={(e) => setStoreName(e.target.value)}
            maxLength={20}
            showCounter={true}
          />
          <PlaceholderB
            // labelIcon={<img src={info} />}   // 예: 작은 물음표 아이콘
            label="가게 이름"
            placeholder="테스트 글자 적기"
            value={storeName}
            onChange={(e) => setStoreName(e.target.value)}
            showCounter={true}
            validation={validateStoreName}
          />
        </section>
      </div>

      {/* Chip: 상태 필터 */}
      <div className="space-y-1 p-3 border border-spacing-2 border-[#5950FF] rounded-2xl">
        <h2 className="text-t3 font-bold">Chip 상태 샘플</h2>
        <Chip chip="a" status="selected" badgeLabel="AI 추천" label="a (status = selected, badgeLabel=AI 추천)" />
        <Chip chip="a" status="disabled" badgeLabel="AI 추천" label="a (status = disabled, badgeLabel=AI 추천)" />
        <Chip chip="d" status="selected" label="d (status = selected)" />
        <Chip chip="d" status="disabled" label="d (status = disabled)" />
        <Chip chip="e" label="입력" />
      </div>

      {/* 색상 사용 예시 */}
      <div className="space-y-1 p-3 border border-spacing-2 border-[#5950FF] rounded-2xl">
        <h2 className="text-t2">Color Manual</h2>
        <hr />
        <h3 className="text-t3">텍스트</h3>
        <p className="text-text-default">기본 · text-text-default</p>
        <p className="text-text-subtle">보조 · text-text-subtle</p>
        <p className="text-text-primary">강조 · text-text-primary</p>
        <p className="text-text-danger">에러 · text-text-danger</p>
        <p className="text-text-disabled">비활성 · text-text-disabled</p>

        <hr />
        {/* Surface / Card */}
        <p className="text-t3 mt-4">Surface / Card</p>
        <div className="bg-bg-white text-text-default border border-border-default p-2 rounded">
          기본 카드 · bg-bg-white + border-border-default + text-text-default
        </div>
        <div className="bg-bg-white-subtle text-text-subtle p-2 rounded">
          서브 섹션 · bg-bg-white-subtle + text-text-subtle
        </div>
        <div className="bg-surface-light-primary-light text-text-primary p-2 rounded">
          Soft 강조 · bg-surface-light-primary-light + text-text-primary
        </div>

        <hr />
        {/* Dim / Overlay */}
        <p className="text-t3 mt-4">Dim / Overlay</p>
        <div className="bg-surface-dark-absolute-dimmed_60 text-text-white-absolute p-2 rounded">
          모달 딤 · bg-surface-dark-absolute-dimmed_60 + text-text-white-absolute
        </div>

        <hr />
        {/* Button */}
        <p className="text-t3">Button</p>
        <button className="bg-btn-primary-fill text-text-white-absolute px-3 py-1.5 rounded-lg">
          Primary · bg-btn-primary-fill + text-text-white-absolute
        </button>
        <button className="bg-btn-secondary-fill text-text-primary border border-btn-secondary-border px-3 py-1.5 rounded-lg">
          Secondary · bg-btn-secondary-fill + border-btn-secondary-border + text-text-primary
        </button>
        <button className="bg-btn-disabled-fill text-text-disabled px-3 py-1.5 rounded-lg" disabled>
          Disabled · bg-btn-disabled-fill + text-text-disabled
        </button>

        <hr />
        {/* Border */}
        <p className="text-t3 mt-4">Border</p>
        <div className="flex flex-wrap gap-2 text-b2">
          <div className="border border-border-subtle px-2 py-1 rounded">Subtle · border-border-subtle</div>
          <div className="border border-border-default px-2 py-1 rounded">Default · border-border-default</div>
          <div className="border border-border-primary px-2 py-1 rounded">Primary · border-border-primary</div>
          <div className="border border-border-darker px-2 py-1 rounded">Strong · border-border-darker</div>
          <div className="border border-border-white-absolute bg-surface-dark-absolute-dimmed_60 text-text-white-absolute px-2 py-1 rounded">
            Dark+White · border-border-white-absolute
          </div>
        </div>
      </div>

      {/* 헤더 예시 */}
      <div className="space-y-1 p-3 border border-spacing-2 border-[#5950FF] rounded-2xl">
        <h2 className="text-t2">Header Group</h2>
        <HeaderIconLR
          title="제목 영역"
          leftIcon={arrowleft}
          onLeftClick={() => alert("back")}
          rightIcon={band_mini}
          onRightClick={() => alert("right")}
        />
        <hr />
        <HeaderIconL
          title="제목 영역"
          icon={arrowleft}
          onIconClick={() => alert("action")}
        />
        <hr />
        <HeaderIconLActionR title="제목 영역" icon={band_mini} actionText="초기화" onAction={() => console.log("입력 클릭")} />
        <hr />
        <HeaderIconLIconsR
          title="제목 영역"
          leftIcon={band_mini}
          onLeftClick={() => alert("back")}
          rightIcons={[
            { icon: band_mini, onClick: () => console.log("첫번째") },
            { icon: band_mini, onClick: () => console.log("두번째") },
            { icon: band_mini, onClick: () => console.log("3") },
          ]}
        />
        <hr />
        <HeaderLeftTitleSubtitle
          title="매장명을 입력해주세요"
          subtitle="주소를 입력해주세요"
          rightIcons={[
            { icon: <div className="w-[24px] h-[24px] rounded bg-[var(--blue-500)]" />, onClick: () => console.log("옵션1") },
            { icon: band_mini, onClick: () => console.log("옵션2") },
          ]}
        />
      </div>

      {/* 버튼 예시 */}
      <div className="space-y-1 p-3 border border-spacing-2 border-btn-secondary-border rounded-2xl">
        <h2 className="text-t2">Button Group & Toast</h2>
        <Button
          type="fill"
          left={band_mini}
        // right={band_mini}
        >Button (no padding box) </Button>
        <hr />
        <SingleButton
          type="alert"
          onClick={() => alert("true")}
        >
          SingleButton (type: alert, fill, border, gray, empty)
        </SingleButton>
        <div className="gap-3 flex">
          <SimpleButton
            label="시간"
            type="select"
            onClick={() => alert("true")}
          />
          <SimpleButton
            label="simple button"
            onClick={() => alert("true")}
          />
          <SimpleButton type="unselect">선택 안 됨</SimpleButton>
          <SimpleButton
            label="unselect"
            type="unselect"
            onClick={() => showToast("텍스트를 복사했습니다")}
          />
          <SimpleButton
            label="simple3"
            type="select"
            onClick={handleCopy}
          >
          </SimpleButton>
        </div>
        <FillButton>FillButton / Button type="fill"</FillButton>
        <hr />
        <BorderButton>BorderButton / Button type="border"</BorderButton>
        <hr />
        <GrayButton>GrayButton / Button type="gray"</GrayButton>
        <hr />
        <EmptyButton>
          EmptyButton <span className="text-red-600">hi</span>
          / Button type="empty"
        </EmptyButton>
        <hr />
        <ThinButton>ThinButton (type: fill, border, gray, empty)</ThinButton>
        <hr />
        <TwinColumn
          topType="fill"
          topText="up"
          topLeftIcon={band_mini}
          onTop={() => alert("true")}
          bottomType="border"
          bottomText="down"
          bottomLeftIcon={band_mini}
          bottomDisabled={true}
        />
        <hr />
        <SplitRowHalf
          leftText="HalfSplit"
          onLeft={() => { alert("false") }}
          rightText="otherHalf"
          leftDisabled={true}
        />
        <hr />
        <SplitRowQuarter
          leftType="border"
          leftText="1/4버튼"
          leftLeftIcon={band_mini}
          onLeft={() => { alert("false") }}
          rightType="fill"
          rightText="SplitRowQuarter"
          rightRightIcon={band_mini}
          rightDisabled={true}
        />
        <hr />
        <CopyButton
          value="1" />
        <hr />
        <div className="flex gap-[8px]">
          <ReserveButton>
            수정
          </ReserveButton>
          <ReserveButton type="blue">
            수정
          </ReserveButton>
        </div>
      </div>

      <hr />
    </div>
  );
}
